// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-buttons-container{display:flex;flex:1;justify-content:space-around}.action-buttons-container .action-buttons-container-text{flex:1;justify-content:space-around}.action-buttons-container .action-button{margin-right:5px;cursor:pointer;opacity:.3;visibility:hidden}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
